import api from "@/lib/API";

export const fetchInventory = async (params) => {
  return await api.get('/inventory', { params });
};

export const fetchInventoryMaster = async (params) => {
  return await api.get('/final-inventory/master-stock', { params });
};

export const updateInventoryItem = async (id, data) => {
  return await api.patch(`/inventory/${id}`, data);
};

export const addItem = async (data) => {
  return await api.post('/inventory', data);
};

export const createPurchase = async (data) => {
  return await api.post('/final-inventory/purchases', data);
};

export const deleteItem = async (id) => {
  return await api.delete(`/inventory/${id}`);
};

export const fetchMaterialRequests = async (params = {}) => {
  return await api.get('/final-inventory/material-requests', { params });
};

export const updateRequestStatus = async (id, status) => {
  return await api.patch(`/final-inventory/material-requests/${id}/status`, { status });
};

export const fetchMaterialReturns = async () => {
  return await api.get('/final-inventory/material-returns');
};

export const fetchPurchases = async (params) => {
  return await api.get('/final-inventory/purchases', { params });
};



export const fetchPurchaseReturns = async (params) => {
  return await api.get('/final-inventory/purchase-returns', { params });
};

export const fetchSaleReturns = async (params) => {
  return await api.get('/inventory/sale-returns', { params });
};

export const getEmptyItem = (serviceType) => ({
  name: "",
  category: serviceType === "Verve" ? "Solar Panels" : "Tower Steel",
  unit: serviceType === "Verve" ? "piece" : "ton",
  availableQty: 0,
  minQty: 0,
  unitPrice: 0,
  supplier: "",
  sku: "",
  itemCode: "",

  serviceType,

  // New Purchase Entry fields
  type: "Stockable",
  brand: "",
  hsnCode: "",
  isUnique: false,
  uniqueName: "",
  hasBatchExpiry: false,
  expiryDate: "",
  barcode: "",
  description: "",
  invoiceNo: "",
  invoiceDate: new Date().toISOString().split('T')[0],
  businessUnit: "VENUS INFRA SERVICES",
  store: "",
  rate: 0,
  quantity: 1,
  bvPoints: 0,
  taxP: 0,
  baseAmount: 0,
  discP: 0,
  discount: 0,
  taxable: 0,
  igst: 0,
  cgst: 0,
  sgst: 0,
  taxAmount: 0,
  netBill: 0,
  chargeAmount: 0,
  adjustments: 0,
  netPayment: 0,
  items: []
});

export const CATEGORIES = {
  solar: ["Solar Panels", "Inverters", "Mounting", "Batteries", "Wiring", "Monitoring", "Electrical"],
  tower: ["Tower Steel", "Tower Hardware", "Safety", "Electrical", "Concrete", "Tools", "Communication"]
};

export const UNITS = ["piece", "set", "ton", "meter", "kit", "box", "roll", "litre", "kg"];
